import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import { toggleClass } from '../utils/dom'
import EventBus from '../core/EventBus'

const STATES = {
    PROGRESS: 'is-in-progress',
    COMPLETED: 'is-completed',
    SET_COMPLETED: 'is-setCompleted'
}

export default class CourseHero extends Component {
    constructor(element) {
        super(element)

        this.hasSetCompleted = false

        this.ref = {
            starCount: null
        }
    }
    prepare() {
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)
    }

    handleStateChange = state => {
        this.render(state)
    }

    render(state) {
        const lessons = Object.entries(state.lessons).map(entry => entry[1])
        const completed = lessons.filter(lesson => lesson.completed).length
        const total = lessons.length
        const hasSetCompleted = Object.entries(state.sets).filter(([key, data]) => data.completed).length

        const level = CourseState.getLevel()
        const courseCompleted = CourseState.isCompleted

        this.ref.starCount.textContent = CourseState.getStarCount()

        toggleClass(this.element, STATES.PROGRESS, completed > 0 && completed < total)
        toggleClass(this.element, STATES.COMPLETED, completed === total)
        toggleClass(this.element, STATES.SET_COMPLETED, hasSetCompleted && completed !== total)
        toggleClass(this.element, 'is-level-4', courseCompleted && level === 4)
        toggleClass(this.element, 'is-level-3', courseCompleted && level === 3)
        toggleClass(this.element, 'is-level-2', courseCompleted && level === 2)
        toggleClass(this.element, 'is-level-1', courseCompleted && level === 1)
        toggleClass(this.element, 'is-level-0', courseCompleted && level === 0)
    }
}